"use client";

import { Outlet } from "react-router-dom";

export default function AestheticReports() {
  return (
    <div className="overflow-x-hidden">
      <div className="space-y-6">
        <div className="px-2 md:px-3">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
